export const PICKING_REF_TROLLEY = 'website-trolley';
export const PICKING_REF_VIEW_ALTERNATIVES = 'website-view-alternatives';
